module.exports = __webpack_public_path__ + "img/_bg.65aa2135.jpg";